// extracted by mini-css-extract-plugin
module.exports = {"loginFormWrapper":"login_loginFormWrapper__mJ3KD","form":"login_form__30FpI"};